module.exports = __webpack_public_path__ + "static/media/wayzata.eb8e3f21.jpg";